import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import MockAdapter from 'axios-mock-adapter';
import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import moment from 'moment-timezone';
import { Spinner } from '@cp-shared-19/frontend-ui';

import { CpContentApi, CpDataApi } from 'cp-xhr';
import 'localization/i18n';
import store from 'store';
import { FR_TIMEZONE } from 'cpfr-common';
import { bronsonTheme } from './config';
import { loadCharlyTheme } from './themes/charly';

const renderApp = (): void => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const App = require('./App').default;
    render(
        <Provider store={store}>
            <Suspense
                fallback={
                    <Spinner center>
                        <p>
                            Veuillez ne pas actualiser ni fermer cette page pendant le traitement de votre demande.
                            Merci de votre patience.
                        </p>
                    </Spinner>
                }
            >
                <App />
            </Suspense>
        </Provider>,
        document.getElementById('root'),
    );
};

if (process.env.NODE_ENV === 'development') {
    // Swap the value to enable local mocks
    const setupMockResponse = false;
    const cpDataApiMock = new MockAdapter(CpDataApi);
    const cpContentApiMock = new MockAdapter(CpContentApi);
    if (setupMockResponse) {
        // TODO define local mocks if necessary
    }
    cpContentApiMock.onAny().passThrough();
    cpDataApiMock.onAny().passThrough();
}

moment.tz.setDefault(FR_TIMEZONE);
loadCharlyTheme(bronsonTheme);
renderApp();

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./App', renderApp);
}
